import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import * as actionTypes from "../../redux/actionTypes";

const ErrorHandler = () => {
  const dispatch = useDispatch();
  const state = useSelector(state => state.other);

  useEffect(() => {
    try {
      console.log(state);
      if(state.errors !== null) errorParser(state.errors);
      if(state.crashes !== null) crashParser(dispatch, state.crashes);
    } catch(err) {}
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state]);

  // ------------------- testing functions -------------------
  const errorParser = (data) => {
    // errors will be resolved at first instance.
    dispatch({ type: actionTypes.CLEAR_ERRORS });

    if(typeof data === 'string'){
      toast.error(data);
    }

    if("message" in data){
      toast.error(data.message);
    }

  }

  const crashParser = (dispatch, data) => { 
    console.log(data);
    // for strings
    if(typeof(data) === 'string'){
      // for request canceller function
      if(data === "REQUEST_CANCELLED"){

      // for expiry of refresh token
      } else if (data === "Internal server error or Refresh Token might have expired. Please login again") {
        toast.error("Session expired, Please login again");
      } else {
        // toast.error("Something went wrong");
      }
    };


    // for objects
    if("message" in data){
      // for request canceller function
      if(data.message === "REQUEST_CANCELLED"){
        
        // for expiry of refresh token
      } else if (data.message === "Internal server error or Refresh Token might have expired. Please login again") {
        // toast.error("Session expired, Please login again");
      } else { 
        toast.error(data.message);
      }
    }else{
      // toast.error("Something went wrong");
    };
    
    dispatch({ type: actionTypes.CLEAR_CRASHES });
  }

}

export default ErrorHandler;